module.exports = __webpack_public_path__ + "static/media/iconParents.411a1d3f.svg";